import React from "react";
import ReactDOM from "react-dom";


const SearchIcon = () =>{
    return(
        <>
           <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 22 22" fill="none">
<path d="M8.87123 0C11.321 0 13.5385 0.968232 15.1438 2.53373C16.7492 4.09923 17.7421 6.26182 17.7421 8.65071C17.7421 10.944 16.8271 13.0283 15.3339 14.5765C15.361 14.596 15.3873 14.6177 15.4121 14.6416L21.7985 20.8609C22.066 21.1203 22.0675 21.5424 21.8011 21.8035C21.535 22.0645 21.1021 22.0656 20.8346 21.8062L14.4482 15.587C14.4076 15.5476 14.3733 15.5046 14.3448 15.4589C12.8369 16.6132 10.9365 17.3016 8.87105 17.3016C6.42131 17.3016 4.20346 16.3334 2.59808 14.7679C0.992894 13.2024 0 11.0396 0 8.65071C0 6.26182 0.992894 4.09923 2.59827 2.53373C4.20364 0.968411 6.4215 0 8.87123 0ZM14.152 3.50107C12.8006 2.18318 10.9336 1.36802 8.87123 1.36802C6.80889 1.36802 4.9417 2.18318 3.59024 3.50107C2.23878 4.81896 1.40287 6.63959 1.40287 8.65071C1.40287 10.6618 2.23878 12.4826 3.59024 13.8005C4.94152 15.1184 6.8087 15.9336 8.87123 15.9336C10.9336 15.9336 12.8006 15.1184 14.152 13.8005C15.5035 12.4828 16.3394 10.662 16.3394 8.65071C16.3394 6.63959 15.5035 4.81896 14.152 3.50107Z" fill="black"/>
</svg>
        </>
    )
}

export default SearchIcon;